"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7113],{

/***/ 27113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ UnifiedCustomerExperiences_UnifiedCustomerExperiences; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
// EXTERNAL MODULE: ../../libs/matcha/components/FeatureBox/index.ts
var FeatureBox = __webpack_require__(33514);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Brandbook.ts + 92 modules
var Brandbook = __webpack_require__(79550);
// EXTERNAL MODULE: ../../libs/matcha/components/IconWrapper/index.ts + 2 modules
var IconWrapper = __webpack_require__(79600);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/TwilioEngage/components/UnifiedCustomerExperiences/UnifiedCustomerExperiences.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }









var features = [{
  heading: "Modern customer data foundation",
  description: "Power all your customer experiences with trusted, real-time, first-party customer data from Twilio Segment\u2019s leading CDP.",
  icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* DataIcon */.d1, {})
}, {
  heading: "Scalable native communications channels",
  description: "Reach global customers using native channels built on the APIs trusted to send billions of communications every day.",
  icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* AttractingIcon */.G_, {})
}, {
  heading: "Powerful, unified orchestration and analytics",
  description: "Build, activate, and measure ROI from one platform to save time and budget while improving campaign performance and efficiency.",
  icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* AnalyticsIcon */.Ie, {})
}];
var copy = {
  heading: "Deliver unified, personalized customer experiences at scale",
  description: "Twilio Engage uniquely puts the power of a native customer data platform (CDP) and native multichannel together in one marketing solution to help companies deliver data-driven personalization and drive efficient growth."
};
var UnifiedCustomerExperiences = function UnifiedCustomerExperiences() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledSectionBase, {
    variant: "centered",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionCopy, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h2",
          children: copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          tag: "p",
          variant: "pLarge",
          children: copy.description
        })]
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, {
        columns: 1,
        overrides: {
          md: 3
        },
        children: features.map(function (feature, index) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledFeatureBoxBase, {
            alignment: "left",
            headerPosition: "top",
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Header */.h4, {
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledIconWrapper, {
                variant: "circle",
                background: "light",
                elevation: 1,
                children: feature.icon
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBox/* Body */.uT, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Title */.Dx, {
                children: feature.heading
              }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Text */.xv, {
                children: feature.description
              })]
            })]
          }, index);
        })
      })
    })]
  });
};

var StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e1qxezw63"
} : 0)( true ? {
  name: "1fygc5t",
  styles: "max-width:1280px"
} : 0);

var StyledSectionCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "e1qxezw62"
} : 0)( true ? {
  name: "1ib8u6k",
  styles: "max-width:844px"
} : 0); // NOTE: We don't have this particular combination of color/background in the theme yet, hence the override


var StyledIconWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(IconWrapper/* default */.Z,  true ? {
  target: "e1qxezw61"
} : 0)("background:", function (_ref) {
  var theme = _ref.theme;
  return theme.palette.neutrals.white[100];
}, ";" + ( true ? "" : 0));

var StyledFeatureBoxBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(FeatureBox/* default */.ZP,  true ? {
  target: "e1qxezw60"
} : 0)("max-width:350px;", function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoints.up("md");
}, "{max-width:unset;}", function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.up("lg");
}, "{padding:0 15px;}", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.up("xxl");
}, "{padding:24px 15px;}" + ( true ? "" : 0));

/* harmony default export */ var UnifiedCustomerExperiences_UnifiedCustomerExperiences = (UnifiedCustomerExperiences);
;// CONCATENATED MODULE: ./src/views/TwilioEngage/components/UnifiedCustomerExperiences/index.ts


/***/ }),

/***/ 33514:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dx": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Dx; },
/* harmony export */   "Hq": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Hq; },
/* harmony export */   "ZP": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.Ob; },
/* harmony export */   "h4": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.h4; },
/* harmony export */   "uT": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.uT; },
/* harmony export */   "xv": function() { return /* reexport safe */ _FeatureBox__WEBPACK_IMPORTED_MODULE_0__.xv; }
/* harmony export */ });
/* harmony import */ var _FeatureBox__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13379);

_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .FeatureBox.displayName */ .Ob.displayName = "FeatureBoxBase";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Body.displayName */ .uT.displayName = "FeatureBox.Body";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Header.displayName */ .h4.displayName = "FeatureBox.Header";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Text.displayName */ .xv.displayName = "FeatureBox.Text";
_FeatureBox__WEBPACK_IMPORTED_MODULE_0__/* .Title.displayName */ .Dx.displayName = "FeatureBox.Title";


/***/ })

}]);